<template>
  <div>
    <span class="titleslight--text font-weight-medium">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>
    <DragUpdateFile 
      ref="cmpDragUpdateFile"
      :key="nKeyCondiciones"
      :bModoPrecargar="true"
      :NoAnexos="nNroAnexos"
      :MaxTamanoFile="nMaxFile"
      :extenAccept="sExtenciones"
      v-bind="oAtributos"
      @onArchivosChange="onArchivosChange"
      @onArchivosSubiendo="onArchivosSubiendo"
    ></DragUpdateFile>
  </div>
</template>

<script>
  import FormMixin from '@/mixins/formularioMixin.js'
  import mxFunciones from "@/mixins/funciones.js";
  import jsAnexos from '@/assets/file/json_anexos.js'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
  import DragUpdateFile from '@/components/DragUpdateFile.vue'

  export default {
    name: 'FormArchivos',
    mixins: [ FormMixin,mxFunciones],
    components: {
      IconoInformacion,
      DragUpdateFile
    },    
    props: {
      inner:{
        type: String,
        default: ''
      },
      condicion:{
        type: String,
        default: 'nNroAnexos=5|sExtenciones=image/*, application/pdf,.zip, .xls, .xlsx|nMaxFile=0'
      },
      titulo:{
        type:String,
        default:''
      },
      oAtributos:{
      type:Object,
      default:()=>{}
    }
    },
    data() {
      return {
        nNroAnexos: 5,
        sExtenciones: 'image/*, application/pdf,.zip, .xls, .xlsx',
        nMaxFile: 0,
        nKeyCondiciones: 0,
        oConfAnexos: {},
        bCargando: false,
        nValorCarga:0,
      }
    },
    methods: {
      onArchivosSubiendo(bSubiendo){
        this.$emit('onArchivosSubiendo', bSubiendo)
      },
      onArchivosChange(aFiles){
        this.$emit('onArchivosChange', aFiles)
        this.$emit('input',aFiles)
      },
      reset() {
        this.oConfAnexos = jsAnexos[this.sTabla]
        this.onValidarCondiciones()
        // reset form to initial state
        //this.$refs.cmpDragUpdateFile.reset()
      },
      onValidarCondiciones(){
        this.nNroAnexos = parseInt(this.onValidarProps('nNroAnexos', '5', this.condicion))
        this.sExtenciones= this.onValidarProps('sExtenciones', 'image/*, application/pdf,.zip, .xls, .xlsx', this.condicion)
        this.nMaxFile =  parseInt(this.onValidarProps('nMaxFile', '0', this.condicion)) // Valor 0 por defecto le decimos al componente que trabajaremos con el parametro sizeFile
        this.nKeyCondiciones++
      }
    },
    watch: {

    },
    computed: {
      isMaximoFile() {
        return this.$refs.cmpDragUpdateFile.estatus === 1
      },
      nIndexArchivos () {
        return this.$refs.cmpDragUpdateFile.aFiles.length
      }
    },
    mounted() {
      this.reset();
    },
  }
</script>

<style lang="scss" >

</style>
